import React, { Component } from 'react';
import { Row, Col, Button, Card, Form, Image } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';
import { PulseLoader } from 'react-spinners';
import {
  formatCurrency,
  formatDate,
  formatPercentage,
  capitalize
} from '../../../../../utils/FormatUtil';
import { isEmail } from '../../../../../utils/ValidationUtil';
import Terms from '../Terms';
import Input from '../../../../../components/Input';
import SecurityFactors from '../../../../../components/SecurityFactors';
import operation from '../../../../../components/SecurityFactors/config/OperationType';
import './result.css';
import InfoWA from '../InfoWithoutAccounts/InfoWA';
import InfoNI from '../InfoNoInvertible/InfoNI';
import updateActive from '../../../../../assets/images/actualizar-saldo-active.png';
import updateInactive from '../../../../../assets/images/actualizar-saldo-neutro.png';
import InfoEC from '../InfoErrorConexion';

class Result extends Component {
  constructor() {
    super();

    this.state = {
      showTerms: false,
      errorEmail: undefined,
      redirectResultOptions: false,
      valueAccountIn: undefined,
      disabledDestino: true,
      valueSelect: -1
    };

    this.handleReturnClick = this.handleReturnClick.bind(this);
    this.handleContractClick = this.handleContractClick.bind(this);
    this.contract = this.contract.bind(this);
    this.handleUpdateSaldo = this.handleUpdateSaldo.bind(this);
  }

  componentDidMount() {
    const { setSimulationSelected, simulationSelected, getAccounts, validate } = this.props;
    setSimulationSelected(simulationSelected);
    getAccounts();
    validate();
  }

  validaInversion() {
    const { accountOut, accounts, amount } = this.props;
    let isOk = false;

    const cuentaFilter = accounts.filter(account => {
      return account.id === accountOut;
    });

    if (cuentaFilter[0] !== undefined) {
      isOk = (amount > cuentaFilter[0].saldoDisponible)
    }
    return isOk;
  }

  handleContractClick(e) {
    e.preventDefault();

    const { email, openErrorModal, montoLimitDap } = this.props;

    if (this.validaInversion()) {
      openErrorModal("El saldo de la cuenta vista es insuficiente para la realizar la inversión.", "error");
    }
    else {
      if (isEmail(email)) {
        ReactGA.event({
          category: 'Click',
          action: 'Invertir DAP'
        });

        const { getChallenge, amount } = this.props;
        if (Number(amount) <= Number(montoLimitDap)) {
          getChallenge(operation.DAP_MENOS_5MM);
        } else {
          getChallenge(operation.DAP_MAYOR_5MM);
        }
      } else {
        this.setState({
          errorEmail: 'Debe indicar un email válido'
        });
      }
    }
  }

  handleReturnClick() {
    const { cleanResult } = this.props;
    cleanResult();
    this.setState({
      redirectResultOptions: true
    })
    ReactGA.event({
      category: 'Click',
      action: 'Volver a Opciones Simulación DAP'
    });
  }

  handleUpdateSaldo() {
    const { getAccounts, accountIn } = this.props;
    if (accountIn) {
      getAccounts(false);
    }

    ReactGA.event({
      category: 'Click',
      action: 'Actualizar saldo cuenta origen'
    });
  }

  contract() {
    const {
      accountOut,
      accountIn,
      email,
      contractTimeDeposit,
      resultSelected,
      montoLimitDap
    } = this.props;

    contractTimeDeposit({
      accountIn,
      accountOut,
      email,
      simulationId: resultSelected.numeroSimulacion,
      value: Number(resultSelected.montoInvertir) <= Number(montoLimitDap) ? 1 : 3
    });
  }

  renderCuentas() {

    const { accounts, changeAccountIn, changeAccountOut, updatingAccounts } = this.props;

    const { valueAccountIn, disabledDestino, valueSelect } = this.state;

    if (accounts.length > 1) {
      return (
        <Form className={updatingAccounts && "semi-transparent"}>
          <Form.Group>
            <Form.Label>Cuenta de origen</Form.Label>
            <Form.Control
              className={this.validaInversion() && !updatingAccounts && "is-invalid"}
              as="select"
              value={valueSelect}
              onChange={e => {
                const { changeAccountOut, changeAccountIn } = this.props;
                changeAccountOut(e.target.value);
                if (valueSelect === -1) {
                  changeAccountIn(e.target.value);
                  this.setState({ valueAccountIn: e.target.value });
                }
                this.setState({ valueSelect: e.target.value });
                this.setState({ disabledDestino: false });
              }
              }
            >
              <option disabled value={-1} key={-1}>Seleccione...</option>
              {accounts.map(cuenta => {
                return (
                  <option key={cuenta.id} value={cuenta.id}>
                    {`Nº ${cuenta.id} - ${formatCurrency(
                      cuenta.saldoDisponible
                    )}`}
                  </option>
                );
              })}
            </Form.Control>
            {this.validaInversion() && !updatingAccounts &&
              <Form.Control.Feedback type="invalid" className="margin-top-none">
                Saldo insuficiente
              </Form.Control.Feedback>
            }
          </Form.Group>

          <Form.Label>Cuenta de destino</Form.Label>
          <Form.Control
            as="select"
            value={valueSelect === -1 ? valueSelect : valueAccountIn}
            disabled={disabledDestino}
            onChange={e => {
              const { changeAccountIn } = this.props;
              changeAccountIn(e.target.value);
              this.setState({ valueAccountIn: e.target.value });
            }}
          >
            <option disabled value={-1} key={-1}>Seleccione...</option>
            {accounts.map(cuenta => {
              return (
                <option key={cuenta.id} value={cuenta.id}>
                  {`Nº ${cuenta.id} - ${formatCurrency(
                    cuenta.saldoDisponible
                  )}`}
                </option>
              );
            })}
          </Form.Control>
          {this.renderUpdateSaldo()}
        </Form>
      );
    }
    else {
      changeAccountIn(accounts[0].id);
      changeAccountOut(accounts[0].id);
      return (
        <Form>
          <Form.Label>Cuenta de origen y destino</Form.Label>
          <Input
            value={`Nº ${accounts[0].id} - ${formatCurrency(
              accounts[0].saldoDisponible
            )}`}
            disabled="true"
            errorText={this.validaInversion() && !updatingAccounts && "Saldo insuficiente"}
          >
          </Input>
          {this.renderUpdateSaldo()}
        </Form>
      );
    }

  }

  renderAccounts() {
    const {
      accounts,
      termsAccepted,
      accountOut,
      accountIn,
      email,
      isLoading,
      challenges,
      invertible,
      primerNombre,
      apellidoPaterno,
      genero,
      unexpectedError,
      available,
      googleAnalytics,
      updatingAccounts,
      montoLimitDap
    } = this.props;

    const { errorEmail, showTerms } = this.state;
    const fullname = capitalize(primerNombre.toLowerCase()).concat(' ').concat(capitalize(apellidoPaterno.toLowerCase()));

    if (isLoading) {
      return (
        <div className="dap_loader-center">
          <PulseLoader size={20} color="#d64b36" />
        </div>
      );
    }

    if (accounts.length > 0 && invertible) {
      return (
        <Form className={updatingAccounts ? "dap_form-resultado semi-transparent" : "dap_form-resultado"}>
          <Terms
            show={showTerms}
            onHide={() => {
              this.setState({ showTerms: false });
            }}
          />
          {this.renderCuentas()}
          <div className="dap_result-email">
            <Input
              label="Email de contacto"
              value={email}
              maxLength={50}
              width="100%"
              helpText="Cambiar el email de contacto no reemplaza los datos de nuestros registros."
              errorText={errorEmail}
              onChange={e => {
                const { changeEmail } = this.props;
                changeEmail(e.target.value);
              }}
              onFocus={() => {
                this.setState({ errorEmail: undefined });
              }}
              onBlur={() => {
                if (!isEmail(email)) {
                  this.setState({
                    errorEmail: 'Debe indicar un email válido'
                  });
                }
              }}
            />
          </div>

          <p className="informacion">
            <b>Importante:</b>
            <br />
            Si deseas actualizar este email, puedes ingresar a la opción{' '}
            <b>“Editar mis Datos”</b> (debes tener tarjeta de coordenadas){' '}
            <b>o visita una de nuestras oficinas.</b>
          </p>
          <Form.Check>
            <Form.Check.Input
              type="checkbox"
              id="checkAccept"
              onChange={e => {
                const { changeTerms } = this.props;

                changeTerms(e.target.checked);
              }}
              checked={termsAccepted}
            />
            He leído y acepto los{' '}
            <span
              className="dap_terms"
              onClick={() => this.setState({ showTerms: true })}
              onKeyPress={() => this.setState({ showTerms: true })}
              role="link"
              tabIndex={0}
            >
              términos y condiciones
            </span>{' '}
            del Depósito a Plazo a contratar.
          </Form.Check>

          <Button
            className="dap_btn-primary"
            onClick={this.handleContractClick}
            disabled={
              !termsAccepted ||
              accountOut === '' ||
              accountIn === '' ||
              errorEmail !== undefined
            }
            type="submit"
          >
            Invertir
          </Button>
          <SecurityFactors
            operation="depósito a plazo"
            challenges={challenges}
            onSuccess={this.contract}
          />
        </Form>
      );
    }

    let infoMsg = <InfoNI nombreCompleto={fullname} genero={genero} invertible={invertible} montoLimitDap={montoLimitDap} />;
    if (!unexpectedError) {
      // monto simulado mayor a permitido
      if (invertible && accounts.length === 0 && available) {
        infoMsg = <InfoWA googleAnalytics={googleAnalytics} />;
      }
    } else {
      infoMsg = <InfoEC />;
    }

    return infoMsg;
  }

  renderUpdateSaldo() {
    const { updatingAccounts, accountIn, accounts } = this.props;

    return (
      <div className={updatingAccounts ? "center" : "dap-right margin-top-none"}>
        {updatingAccounts && <PulseLoader size={20} color="#d64b36" />}
        {!updatingAccounts &&
          <span
            role="link"
            onClick={this.handleUpdateSaldo}
            onKeyPress={this.handleUpdateSaldo}
            tabIndex={0}
            className={accountIn ? "dap_terms" : "dap_terms disabled"}
          >
            <Image src={accountIn ? updateActive : updateInactive} alt="Actualizar saldo" className="dap-img-update" /> {accounts.length === 1 ? "Actualizar saldo" : "Actualizar saldos"}
          </span>}
      </div>
    );
  }

  render() {
    const { resultSelected, step } = this.props;
    const { redirectResultOptions } = this.state;

    if (redirectResultOptions) {
      return <Redirect to="/resultado-opciones" />;
    }
    if (step === 3) {
      return <Redirect to="/resumen" />;
    }

    return (
      <React.Fragment>
        <Row noGutters className="rotulos">
          <Col md={12}>
            <p>Resultados de la simulación y configuración de la inversión</p>
          </Col>
        </Row>
        <Card body className="table_result">
          <Row noGutters>
            <Col md={{ span: 4, offset: 1 }} sm={6} xs={12}>
              <h5>Detalle de la simulación</h5>
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="col">Monto a invertir</th>
                    <th scope="col">{formatCurrency(resultSelected.montoInvertir)}</th>
                  </tr>
                  <tr>
                    <th scope="col">Ganancia</th>
                    <th scope="col">
                      {formatCurrency(resultSelected.interes)}
                    </th>
                  </tr>

                  <tr>
                    <th scope="col">Monto al vencimiento</th>
                    <th scope="col">{formatCurrency(resultSelected.montoRecibir)}</th>
                  </tr>

                  <tr>
                    <th>Plazo</th>
                    <th>{`${resultSelected.plazo} días`}</th>
                  </tr>

                  <tr>
                    <th>Tipo de depósito</th>
                    <th>{capitalize((resultSelected.tipo || '').toLowerCase())}</th>
                  </tr>

                  <tr>
                    <th>Fecha de inicio</th>
                    <th>{formatDate(resultSelected.fechaInicio)}</th>
                  </tr>

                  <tr>
                    <th>Fecha de vencimiento</th>
                    <th>{formatDate(resultSelected.fechaVencimiento)}</th>
                  </tr>

                  <tr>
                    <th><br></br></th>
                  </tr>

                  <tr className="dap_verde">
                    <td>Tasa base</td>
                    <td>{formatPercentage(resultSelected.tasaInteres)}</td>
                  </tr>

                  <tr>
                    <th colSpan="6">Tasa definida en base a un período de 30 días.</th>
                  </tr>

                  <tr className="dap_verde">
                    <td>Tasa período</td>
                    <td>{formatPercentage(resultSelected.tasaPeriodo)}</td>
                  </tr>
                  <tr>
                    <th colSpan="6">Tasa de interés total para todo el período estipulado en la captación. Resulta de la división de la Tasa Base por 30 y multiplicándola por el número de días de la Captación.</th>
                  </tr>
                  <tr>
                    <th colSpan="6" className="pt-3"><b>Tasa preferencial para canal Web y App.</b></th>
                  </tr>

                </tbody>
              </table>
              <Button
                onClick={this.handleReturnClick}
                className="dap_btn-secondary"
              >
                Volver
              </Button>
              <div className="dap_scroll" />
            </Col>

            <Col
              md={{ span: 5, offset: 1 }}
              sm={6}
              xs={12}
              className="dap_border-izquierda"
            >
              {this.renderAccounts()}
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

export default Result;
